module.exports = __webpack_public_path__ + "static/media/sample portrait.dabdc6a6.png";